module.exports = __webpack_public_path__ + "img/AmaTime.f5927ec0.png";